import * as types from "../actionTypes/mpinActionTypes"

const initialState = {
    mpin_login_payload:"",
    mpin_login_authtoken:"",
    mpin_login_status: "",
    mpin_login_code: "",
    mpin_error_message:"",
    error: false,
}

export const MpinReducer = (
    state = initialState,
    action:any
) => {  
    switch (action.type) {
        case types.MPIN_LOGIN_SUCCESS:
            return {
                ...state,
                mpin_login_payload:action.payload.data?.payload,
                mpin_login_authtoken:action.payload.data?.token,
                mpin_login_status: action.payload.status,
                mpin_login_code: action.payload.code,
                mpin_error_message: action.payload.error_message,
                error: false,
            };
        case types.MPIN_LOGIN_RESET:
            return {
                ...state,
                mpin_login_code: '',
                error: false
            };
        case types.MPIN_LOGIN_ERROR:
            return {
                ...state,
                error: true,
                // mpin_login_code: action.payload?.code,
                // mpin_error_message: action.payload?.error_message,
            };
        default:
            return state
    }
}